import { getAgents, deleteAgent, addOrUpdateAgent } from "@/api";

export default {
  namespaced: true,
  state: {
    agents: [], // 全量缓存
    loading: false,
  },
  mutations: {
    SET_AGENTS(state, agents) {
      state.agents = agents;
    },
    ADD_AGENT(state, agent) {
      state.agents.push(agent);
    },
    UPDATE_AGENT(state, agent) {
      const idx = state.agents.findIndex((a) => a.agent_id === agent.agent_id);
      if (idx !== -1) state.agents.splice(idx, 1, agent);
    },
    DELETE_AGENT(state, agentId) {
      state.agents = state.agents.filter((a) => a.agent_id !== agentId);
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAgents({ commit }, opt = {}) {
      commit("SET_LOADING", true);
      const { list } = await getAgents(opt); // 你的API要支持参数
      commit("SET_AGENTS", list);
      commit("SET_LOADING", false);
    },
    async createAgent({ dispatch }, agent) {
      await addOrUpdateAgent(agent);
      await dispatch("fetchAgents");
    },
    async updateAgent({ dispatch }, agent) {
      await addOrUpdateAgent(agent);
      await dispatch("fetchAgents");
    },
    async deleteAgent({ dispatch }, agentId) {
      await deleteAgent(agentId);
      await dispatch("fetchAgents");
    },
    async fetchAgentById({ state, dispatch, getters }, id) {
      if (state.agents.length === 0) {
        await dispatch("fetchAgents");
      }
      return getters.getAgentById(id);
    },
  },
  getters: {
    getAgentById: (state) => (id) => {
      return state.agents.find((a) => a.agent_id === id);
    },
    agents: (state) => {
      return state.agents;
    },
  },
};
